var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLayer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3948 8.3607C10.9024 9.17472 9.0987 9.17472 7.60632 8.3607L0.833984 4.6667L7.60632 0.972697C9.0987 0.158675 10.9024 0.158674 12.3948 0.972696L19.1671 4.6667L12.3948 8.3607ZM12.3911 11.6986C10.9007 12.51 9.10045 12.51 7.61001 11.6986L1.31315 8.27083L3.06313 7.31251L7.60263 9.79356C9.09694 10.6103 10.9042 10.6103 12.3985 9.79356L16.938 7.31251L18.688 8.27083L12.3911 11.6986ZM12.3911 15.0319C10.9007 15.8433 9.10045 15.8433 7.61001 15.0319L1.31315 11.6041L3.06313 10.6458L7.60263 13.1269C9.09694 13.9436 10.9042 13.9436 12.3985 13.1269L16.938 10.6458L18.688 11.6041L12.3911 15.0319ZM7.6052 6.46348C9.09816 7.27832 10.903 7.27832 12.3959 6.46348L15.688 4.6667L12.3959 2.86992C10.903 2.05508 9.09816 2.05508 7.6052 2.86992L4.31312 4.6667L7.6052 6.46348Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer);
export default __webpack_public_path__ + "static/media/layer.88e1fed0b7ef57f81d6be64c381f529c.svg";
export { ForwardRef as ReactComponent };